import { CHARMS } from '../charms/catalog';
import { HEROES } from '../heroes';
import { POWERUPS, powerIsFree } from '../powerups';
import type { HeroId } from '../types';
import type { Profile } from './types';

const HERO_IDS = Object.keys(HEROES) as HeroId[];

/** Every critter, trick stack, and Charm. Used by the VITE_UNLOCK_ALL build. */
export function applyUnlockAll(profile: Profile): void {
  for (const id of HERO_IDS) {
    if (!profile.critters[id]) profile.critters[id] = { unlocked: true };
    profile.critters[id].unlocked = true;
  }
  if (!profile.trickStock) profile.trickStock = {};
  for (const power of POWERUPS) {
    if (powerIsFree(power)) continue;
    profile.tricks[power.id] = { level: 1 };
    profile.trickStock[power.id] = Math.max(profile.trickStock[power.id] ?? 0, 99);
  }
  if (!profile.charms) profile.charms = {};
  for (const charm of CHARMS) {
    profile.charms[charm.id] = { count: charm.tier === 'twig' ? 1 : 9, regrowAt: null };
  }
  profile.bestTrophies = Math.max(profile.bestTrophies, 5000);
  profile.trophies = Math.max(profile.trophies, profile.bestTrophies);
}

export { unlockBuild } from './storageKey';
